var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5453",
    "data-name": "Rectangle 5453",
    width: 20.974,
    height: 17.043,
    fill: "#1228f3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(0.5 -0.205)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14511",
    "data-name": "Rectangle 14511",
    width: 36,
    height: 37,
    rx: 6,
    transform: "translate(-0.5 0.205)",
    fill: "#1228f3",
    opacity: 0.154
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40305",
    "data-name": "Group 40305",
    transform: "translate(7.183 10.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16973",
    "data-name": "Group 16973",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48385",
    "data-name": "Path 48385",
    d: "M18.827,4.243c.013.185.013.37.013.556A12.161,12.161,0,0,1,6.6,17.043v0A12.182,12.182,0,0,1,0,15.111a8.753,8.753,0,0,0,1.024.062,8.641,8.641,0,0,0,5.344-1.846,4.309,4.309,0,0,1-4.02-2.988,4.289,4.289,0,0,0,1.943-.074A4.3,4.3,0,0,1,.839,6.047V5.993a4.276,4.276,0,0,0,1.953.539A4.309,4.309,0,0,1,1.46.785a12.213,12.213,0,0,0,8.869,4.5,4.307,4.307,0,0,1,7.333-3.925A8.635,8.635,0,0,0,20.4.312,4.319,4.319,0,0,1,18.5,2.692a8.558,8.558,0,0,0,2.471-.677,8.742,8.742,0,0,1-2.147,2.229",
    transform: "translate(0 0)",
    fill: "#1228f3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4523f76522b46a3305700fbb8fc41c8a.svg";
export { ForwardRef as ReactComponent };